export default __webpack_public_path__ + "static/media/A7.fb6daab4.png";